import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import './OrganizerFilterButton.css';

class OrganizerFilterButton extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired,
    isBig: PropTypes.bool.isRequired
  };

  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    organizeFilterCount: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired
  };

  render() {
    const { organizeFilterCount, filterDisabled, onClick, isBig } = this.props;
    const { t } = this.context;
    return (
      <div>
        {isBig ? (
          <Button
            color="link"
            className={`organizerFilterButton ${organizeFilterCount > 0 && 'organizerAppliedFilterButton'}`}
            disabled={filterDisabled}
            onClick={onClick}>
            {t('buttons.organizers')}
            {organizeFilterCount !== 0 && ` · ${organizeFilterCount}`}
          </Button>
        ) : (
          <i
            className={`togo-icon togo-icon-add-person filterMobileIcon ${filterDisabled ? 'disabledIcons' : ''}`}
            onClick={() => {
              if (!filterDisabled) {
                onClick();
              }
            }}
          />
        )}
      </div>
    );
  }
}

export default OrganizerFilterButton;



// WEBPACK FOOTER //
// ./src/Components/OrganizerFilterButton/OrganizerFilterButton.js